import React from "react";
import CustomSearch from "../../components/common/CustomSearch";
import Grid from "../../components/layout/grid/Grid";
import CustomSwitch from "../../components/common/CustomSwitch";
import { changeAdvisorCompanyAccessFn } from "../../Services/advisorService";

const CompanyTab = ({ data, setDep, id }) => {
  console.log("companydata", data);

  const advisorId = data?.find((d) => d.advisor_id)?.advisor_id;

  const handleCompanyAccessToggle = async (companyId, currentAccess) => {
    if (!advisorId) {
      const payload = {
        advisor_company_access_array: [
          {
            advisor_id: id,
            company_id: companyId,
            is_access: !currentAccess,
          },
        ],
      };

      try {
        const res = await changeAdvisorCompanyAccessFn(payload);
        console.log("Access updated:", res?.data);
        setDep((prev) => !prev);
      } catch (err) {
        console.error("Error updating access:", err);
      }
    } else {
      const payload = {
        advisor_company_access_array: [
          {
            advisor_id: advisorId,
            company_id: companyId,
            is_access: !currentAccess,
          },
        ],
      };

      try {
        const res = await changeAdvisorCompanyAccessFn(payload);
        console.log("Access updated:", res?.data);
        setDep((prev) => !prev);
      } catch (err) {
        console.error("Error updating access:", err);
      }
    }

    const payload = {
      advisor_company_access_array: [
        {
          advisor_id: advisorId,
          company_id: companyId,
          is_access: !currentAccess,
        },
      ],
    };

    try {
      const res = await changeAdvisorCompanyAccessFn(payload);
      console.log("Access updated:", res?.data);
      setDep((prev) => !prev);
    } catch (err) {
      console.error("Error updating access:", err);
    }
  };

  return (
    <Grid container className="flex m-1">
      {data?.map((item, index) => (
        <Grid
          key={item.company_id || index}
          item
          xs={4}
          className="border border-[#E2EBF3] rounded-md m-2"
        >
          <div className="flex items-center justify-start p-2">
            <CustomSwitch
              name={item.company_name.toLowerCase().replace(/\s+/g, "-")}
              value={item.is_access}
              onChange={() =>
                handleCompanyAccessToggle(item.company_id, item.is_access)
              }
            />
            <span className="ml-2 font-semibold">{item.company_name}</span>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

export default CompanyTab;
